import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { useTranslation } from "@/hooks/useTranslation";

interface EventDetailsSectionProps {
  eventName: string;
  eventDate: string;
  onEventNameChange: (value: string) => void;
  onEventDateChange: (value: string) => void;
  eventNameError?: string;
  eventDateError?: string;
}

export function EventDetailsSection({
  eventName,
  eventDate,
  onEventNameChange,
  onEventDateChange,
  eventNameError,
  eventDateError,
}: EventDetailsSectionProps) {
  const { t } = useTranslation();
  return (
    <div className="space-y-4">
      <Label>{t("events.form.eventDetails")}</Label>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <Label htmlFor="event-name">
            {t("events.name")} <span className="text-destructive">*</span>
          </Label>
          <Input
            id="event-name"
            name="name"
            value={eventName}
            onChange={(e) => onEventNameChange(e.target.value)}
            placeholder={t("events.namePlaceholder")}
            className="mt-1"
            data-testid="event-name-input"
          />
          {eventNameError && (
            <p className="text-sm text-destructive mt-1">{eventNameError}</p>
          )}
        </div>
        <div>
          <Label htmlFor="event-date">
            {t("events.date")}
          </Label>
          <Input
            id="event-date"
            name="date"
            type="date"
            value={eventDate}
            onChange={(e) => onEventDateChange(e.target.value)}
            className="mt-1"
            data-testid="event-date-input"
          />
          {eventDateError && (
            <p className="text-sm text-destructive mt-1">{eventDateError}</p>
          )}
        </div>
      </div>
    </div>
  );
}

